<template>
    <base-loader v-if="loading"/>
    <table v-else class="table is-striped is-fullwidth">
        <tbody>
            <space-members-item
                v-for="member in members"
                :member="member"
                :space="space"
                :key="member.id"
                @removed="$emit('removed')"/>
        </tbody>
    </table>
</template>

<script>
import SpaceMembersItem from './SpaceMembersItem.vue';

export default {
    components: { SpaceMembersItem },
    props: ['members', 'space', 'loading'],
};
</script>
